<div class="modal-header">
    <h4 class="modal-title">{{ "delivery_module.task" | translate }}</h4>
    <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title" (click)="modal.close()"></button>
</div>
<div class="modal-body" [formGroup]="taskForm">
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="nameAE"
                formControlName="nameAE"
                [invalid]="submitted && taskForm.get('nameAE')?.invalid!"
                [label]="'common.form.label.nameAE' | translate"
                [setValidator]="formValidation"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="nameEN"
                formControlName="nameEN"
                [invalid]="submitted && taskForm.get('nameEN')?.invalid!"
                [label]="'common.form.label.nameEN' | translate"
                [setValidator]="formValidation"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="dscAE"
                formControlName="dscAE"
                [invalid]="submitted && taskForm.get('dscAE')?.invalid!"
                [label]="'common.form.label.descriptionAE' | translate"
                [setValidator]="formValidation"
                [isTextArea]="true"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input
                controlName="dscEN"
                formControlName="dscEN"
                [invalid]="submitted && taskForm.get('dscEN')?.invalid!"
                [label]="'common.form.label.descriptionEN' | translate"
                [setValidator]="formValidation"
                [isTextArea]="true"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input-date
                controlName="startDate"
                formControlName="startDate"
                [invalid]="submitted && taskForm.get('startDate')?.invalid!"
                [label]="'national_projects.planned_start_date' | translate"
                [setValidator]="formValidation"
                [minDate]="taskLimits.min"
                [maxDate]="taskLimits.max"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-input-date
                controlName="endDate"
                formControlName="endDate"
                [invalid]="submitted && taskForm.get('endDate')?.invalid!"
                [label]="'national_projects.planned_end_date' | translate"
                [setValidator]="formValidation"
                [minDate]="taskLimits.min"
                [maxDate]="taskLimits.max"
            />
        </div>
    </div>
    <div class="row">
        <div class="col-sm-6 col-xs-12">
            <adaa-form-dropdown
                controlName="entityId"
                formControlName="entityId"
                [options]="entities"
                [invalid]="submitted && taskForm.get('entityId')?.invalid!"
                [label]="'national_projects.accountable_entity' | translate"
                [setValidator]="formValidation"
                (inputChanges)="entityIdChanged($event)"
            />
        </div>
        <div class="col-sm-6 col-xs-12">
            <adaa-form-dropdown
                controlName="otherEntityId"
                formControlName="otherEntityId"
                [clearable]="true"
                [options]="otherEntities"
                [invalid]="submitted && taskForm.get('otherEntityId')?.invalid!"
                [label]="'national_projects.other_accountable_entity' | translate"
                [setValidator]="formValidation"
                (inputChanges)="otherEntityIdChanged($event)"
            />
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <adaa-form-checkbox controlName="completed" formControlName="completed" [label]="'national_projects.completed' | translate" />
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">{{ "common.form.button.close" | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="save()">{{ "common.form.button.save" | translate }}</button>
</div>
